import { internalAxios } from '../utils/axios/internal';

// eslint-disable-next-line
export const indicatorService = async ({ idlot, currency }) => {
  const response = await internalAxios.get(`/api/artdbweb/indicator/get/${idlot}?currency=${currency}&format=json`);
  return response.data;
};
